import React, { Component, useState, } from "react";
import { GoogleMap, LoadScript, Marker } from "@react-google-maps/api";
import { HomepageContext } from "context/homepageProvider";

import "scss/components/homepage/googleMapsDevices.scss";

import black_pin from "assets/map_icon/black_pin.png";
import green_pin from "assets/map_icon/green_pin.png";
import orange_pin from "assets/map_icon/orange_pin.png";
import red_pin from "assets/map_icon/red_pin.png";
import axios from 'axios';

const API_URL = 'https://clp-service.honey.co.th';
const ACCESS_TOKEN = 'e2b1e20a-b26a-4d3b-9c80-8ea29c05f046';


export default class GoogleMapsDevices extends Component {

  constructor(props) {
    super(props);
    this.state = {
      pinSize: null,
      model: "",
      greenPinBlinking: false,
      deviceDataDevice: null,
      deviceDataClient: null,
      maintenanceList: [],
      clpmemberList: [],

    };
  }

  componentDidMount() {
    this.getAllLinkDevice({ name: "", level: -1 });
    const data = {
      state: ["contacted", "draft", "contact_fail", "later", "process"],
      pic: null,
      uid: null,
    };
    this.setDeviceData(data);
    this.fetchDataClient();
    this.fetchDataDevice();
    this.getService();
    this.getClpMembers();
    // console.log("dd", this.context.machineList)
    setInterval(() => {
      this.setState((prevState) => ({
        greenPinBlinking: !prevState.greenPinBlinking,
      }));
    }, 1000);
  }

  setDeviceData = async (data) => {
    await this.context.getMaintenances(data);
    this.setState({
      maintenanceList: this.context.maintenanceList.slice(
        this.state.begin,
        this.state.end
      ),
    });
    // console.log("MAdata", this.state.maintenanceList)
  };

  // เช็ค DataClient ถ้ามีข้อมูลให้ไปดึง api จาก device
  fetchDataClient = async () => {
    const clientResponse = await axios.get(`${API_URL}/mqtt/clients`, {
      headers: { Authorization: `Bearer ${ACCESS_TOKEN}` },
    });

    if (clientResponse != null) {
      this.setState({ deviceDataClient: clientResponse.data.data });
    }
    // console.log("clientData", this.state.deviceDataClient);
  }

  fetchDataDevice = async () => {
    const deviceResponse = await axios.get(`${API_URL}/mqtt/devices`, {
      headers: { Authorization: `Bearer ${ACCESS_TOKEN}` },
    });

    if (deviceResponse.data.data) {
      this.setState({ deviceDataDevice: deviceResponse.data.data });
    }
    // console.log("deviceData", this.state.deviceDataDevice)
  }

  getService = async () => {
    await this.context.getService();
    this.setState({
      serviceList: this.context.serviceList
    });
    // console.log("SVMapdata", this.state.serviceList)
    console.log("machineData", this.context.machineList)
  };

  getClpMembers = async () => {
    await this.context.getClpMembers();
    this.setState({
      clpmemberList: this.context.clpmemberList
    });
    console.log("memberList", this.context.clpmemberList)
  };

  getAllLinkDevice = async (data) => {
    await this.context.getAllLinkDevice(data);
    this.setState({
      devicesList: this.context.allDevicesList.slice(
        this.state.begin,
        this.state.end
      ),
    });
    console.log("allDevicesList", this.state.devicesList)
  };

  // updateShowStatus = async (device) => {
  //   const { getMasterParts, getPastStatus } = this.context;
  //   if (device?.name !== undefined) {
  //     await getMasterParts({ model: device?.model });
  //     await getPastStatus({ name: device?.name });
  //   }
  //   this.setState({
  //     isShowStatus: !this.state.isShowStatus,
  //     deviceDetail: device,
  //   });
  // };

  render() {
    const containerStyle = {
      width: "100%",
      height: "450px",
    };

    const center = {
      lat: 13.736717,
      lng: 100.523186,
    };

    return (
      <div className="googleMapsDevices">
        <LoadScript googleMapsApiKey="AIzaSyDynDZSFQuvMWZ8lafc1LarFWiUlavcM2Y">
          <GoogleMap
            mapContainerStyle={containerStyle}
            center={center}
            zoom={6}
            onLoad={(map) => {
              this.setState({
                pinSize: new window.google.maps.Size(20, 30),
              });
            }}
          >
            
            {this.context.machineList?.total_machine > 0 &&
              this.context.machineList?.machines.map((machine, idx) => (
                <Marker
                  key={idx}
                  icon={{
                    url: this.state.devicesList?.find(
                      (item) =>
                        item.iot_serial === machine.iot_serial &&
                        item.caution_level === 2)
                      ? red_pin

                      : this.state.devicesList?.find(
                        (item) =>
                          item.iot_serial === machine.iot_serial &&
                          item.caution_level === 1)
                        ? orange_pin

                        : this.state.devicesList?.find(
                          (item) =>
                            item.iot_serial === machine.iot_serial &&
                            item.caution_level === 3)
                          ? black_pin

                          : this.state.devicesList?.find(
                            (item) =>
                              item.caution_level === 0)
                            ? green_pin : "",

                    scaledSize: this.state.pinSize,
                  }}

                  position={{
                    lat: parseFloat(this.state.deviceDataDevice &&
                      this.state.deviceDataDevice[machine.iot_serial] ?
                      this.state.deviceDataDevice[machine.iot_serial].lat
                      : machine.lat),

                    lng: parseFloat(this.state.deviceDataDevice &&
                      this.state.deviceDataDevice[machine.iot_serial] ?
                      this.state.deviceDataDevice[machine.iot_serial].lng
                      : machine.long),
                  }}

                  animation={
                    this.clientResponse && this.clientResponse.clientId === machine.iot_serial
                      && this.clientResponse.online === true
                      ? window.google.maps.Animation.BOUNCE
                      : null
                  }
                  
                  onClick={() => {
                    const { maintenanceList, clpmemberList } = this.state;

                    const item = maintenanceList?.find((item) => item.deviceSerial === this.state.devicesList?.iotSerial                  ) 
                    || clpmemberList.memberListAll.find((item) => item.clp_serial
                        === machine.name);

                    if (item) {
                      if (item.documentNo) {
                        window.location.href = `/sa-received/${item.documentNo}`;
                      } else if (item.username) {
                        window.location.href = `/customers/${item.username}`;
                      }
                    }
                  }}                
                />
              ))}
          </GoogleMap>
        </LoadScript>
      </div>
    );
  }
}
GoogleMapsDevices.contextType = HomepageContext;
